import React, { useState } from 'react';
import { Check, Link2 } from 'lucide-react';
type CopyLinkButtonProps = {
  hash?: string;
  label?: string;
  iconOnly?: boolean;
};
export function CopyLinkButton({
  hash,
  label = 'Copiar enlace',
  iconOnly = false
}: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const url = `${window.location.origin}${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ''}`;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };
  const Icon = copied ? Check : Link2;
  const text = copied ? 'Enlace copiado' : label;
  if (iconOnly) {
    return <button type="button" onClick={copy} aria-label={text} title={text} className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${copied ? 'text-[#D4AF37]' : 'text-gray-500 hover:bg-white/5 hover:text-white'}`} data-id="element-309" data-mp="yborj64tcxao">
        <Icon className="h-4 w-4" data-id="element-310" data-mp="3v7dyz8crhpae" />
      </button>;
  }
  return <button type="button" onClick={copy} className="inline-flex h-10 items-center gap-2 rounded-full border border-white/15 px-4 text-sm font-semibold text-gray-200 whitespace-nowrap transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white" data-id="element-311" data-mp="3z8ksk2q20pj">
      <Icon className={`h-4 w-4 ${copied ? 'text-[#D4AF37]' : ''}`} aria-hidden="true" data-id="element-312" data-mp="ioxzzj7ng58t" />
      <span aria-live="polite" data-id="element-313" data-mp="mq9gmz8jpg4v">{text}</span>
    </button>;
}